// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2748":"7ce7e52e","5257":"6fa6ee63"}[chunkId] + ".chunk.css";
};